// Controller interface
interface Controller {
  onLoad(): void;
}

// Constructor function type
type ControllerConstructor = new () => Controller;

const tablemill = {
  activateControllerFor: (name: string, ctor: ControllerConstructor): void => {
    tablemill.onController(name, () => {
      const controller = new ctor();
      controller.onLoad();
    });
  },
  onController: (name: string, f: () => void): void => {
    jQuery(($) => {
      if ($("body").hasClass(name)) {
        f();
      }
    });
  },
  FIRST_DATA_DATE: new Date(2009, 0, 1),
};

export { tablemill };
